import { IQuery } from 'core-ts-types';
import { Query } from 'utility-ts-orm';
import { CourseAlertsModel, ICourseAlerts } from '../models/course_alerts_model';
import * as _4 from 'lodash4';

export class CourseAlertsQuery implements IQuery {
  private _result: ICourseAlerts;

  constructor(private ngCourseAlertsModel: CourseAlertsModel) {
    Query.registerQuery(this, ngCourseAlertsModel);
  }

  run() {
    this._result = this.ngCourseAlertsModel.read();
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngCourseAlertsQuery', CourseAlertsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/course_alerts/queries/course_alerts_query.ts